import * as React from "react";

export const MenuIcon = (props: any) => (
  <svg
    width={16}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16 10.8c0-.438-.302-.8-.667-.8H.667c-.365 0-.667.363-.667.8v.4c0 .438.302.8.667.8h14.666c.365 0 .667-.363.667-.8v-.4ZM15.333 5c.365 0 .667.362.667.8v.4c0 .438-.302.8-.667.8H.667C.302 7 0 6.638 0 6.2v-.4c0-.438.302-.8.667-.8h14.666ZM15.333 0c.365 0 .667.362.667.8v.4c0 .438-.302.8-.667.8H.667C.302 2 0 1.637 0 1.2V.8C0 .362.302 0 .667 0h14.666Z"
      fill="#ffffff"
    />
  </svg>
);
